<template>
  <div>
    <b-card>
      <title-text />
      <content-text />
      <ordering-number />
    </b-card>
    <b-row>
      <b-col><file-card-tr :refresh-data="refreshData" /></b-col>
      <b-col><file-card-en :refresh-data="refreshData" /></b-col>
      <b-col><file-card-de :refresh-data="refreshData" /></b-col>
    </b-row>
    <b-button
      variant="primary"
      :disabled="itemData.submitStatus"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </div>
</template>

<script>
import {
  BCard, BButton, BRow, BCol,
} from 'bootstrap-vue'

import { required } from '@validations'

import TitleText from '@/views/Admin/Contents/elements/TitleText.vue'
import ContentText from '@/views/Admin/Contents/elements/ContentText.vue'
import OrderingNumber from '@/views/Admin/Contents/elements/OrderingNumber.vue'
import FileCardTr from '@/views/Admin/Contents/elements/FileCardTr.vue'
import FileCardEn from '@/views/Admin/Contents/elements/FileCardEn.vue'
import FileCardDe from '@/views/Admin/Contents/elements/FileCardDe.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    TitleText,
    ContentText,
    OrderingNumber,
    FileCardTr,
    FileCardEn,
    FileCardDe,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['contents/dataItem']
    },
  },
  mounted() {
    this.itemData.submitStatus = false
  },
  methods: {
    refreshData() {
      if (this.$route.params.id) {
        this.$store.dispatch('contents/getDataItem', this.$route.params.id)
      }
    },
  },
}
</script>
